import img1 from "../../../Images/protfolio/prot_galary/pg1.jpg";
import img2 from "../../../Images/protfolio/prot_galary/pg2.jpg";
import img3 from "../../../Images/protfolio/prot_galary/pg3.jpg";
import img4 from "../../../Images/protfolio/prot_galary/pg4.jpg";
import img5 from "../../../Images/protfolio/prot_galary/pg5.jpg";
import img6 from "../../../Images/protfolio/prot_galary/pg6.jpg";
import img7 from "../../../Images/protfolio/prot_slider/p1.jpg";
import img8 from "../../../Images/protfolio/prot_slider/p2.jpg";
import img9 from "../../../Images/protfolio/prot_slider/p3.jpg";
import img10 from "../../../Images/protfolio/prot_slider/p4.jpg";
import img11 from "../../../Images/protfolio/prot_slider/p5.jpg";

const galaryImg = [
  {
    id: 1,
    projectNmae: "Project 01",
    frameWork: "react",
    clint: "Red Chillies Entertainment",
    category: "web",
    img: img1,
  },
  {
    id: 2,
    projectNmae: "Project 02",
    frameWork: "laravel",
    clint: "Red Chillies Entertainment",
    category: "web",
    img: img2,
  },
  {
    id: 3,
    projectNmae: "Project 03",
    frameWork: "react",
    clint: "Red Chillies Entertainment",
    category: "GraphicDesign",
    img: img3,
  },
  {
    id: 4,
    projectNmae: "Project 04",
    frameWork: "react",
    clint: "Red Chillies Entertainment",
    category: "GraphicDesign",
    img: img4,
  },
  {
    id: 5,
    projectNmae: "Project 05",
    frameWork: "react",
    clint: "Red Chillies Entertainment",
    category: "UI/UXDesign",
    img: img5,
  },
  {
    id: 6,
    projectNmae: "Project 06",
    frameWork: "react",
    clint: "Red Chillies Entertainment",
    category: "UI/UXDesign",
    img: img6,
  },
  {
    id: 7,
    projectNmae: "Project 07",
    frameWork: "react",
    clint: "Red Chillies Entertainment",
    category: "UI/UXDesign",
    img: img7,
  },
  {
    id: 8,
    projectNmae: "Project 08",
    frameWork: "react",
    clint: "Red Chillies Entertainment",
    category: "DigitalMarketing",
    img: img8,
  },
  {
    id: 9,
    projectNmae: "Project 09",
    frameWork: "react",
    clint: "Red Chillies Entertainment",
    category: "DigitalMarketing",
    img: img9,
  },
  {
    id: 10,
    projectNmae: "Project 10",
    frameWork: "react",
    clint: "Red Chillies Entertainment",
    category: "DigitalMarketing",
    img: img10,
  },
  {
    id: 11,
    projectNmae: "Project 09",
    frameWork: "react",
    clint: "Red Chillies Entertainment",
    category: "Partners",
    img: img11,
  },
];

export default galaryImg;
